import {WithdrawalResponse, WithdrawalRequest} from "../../domain/types";
import {V2WithdrawalResponse} from "./mapper.types";

/**
 * Maps v2 API responses to domain types.
 * v2 uses camelCase and includes Stripe fields.
 *
 * Pure TypeScript - no React imports.
 */
export const WithdrawalMapperV2 = {
  /**
   * Maps v2 API response to domain WithdrawalResponse.
   * Passthrough since v2 already uses camelCase.
   */
  toDomain(response: V2WithdrawalResponse): WithdrawalResponse {
    return {
      id: response.id,
      amount: response.amount,
      fee: response.fee,
      currency: response.currency,
      reference: response.reference,
      statusName: response.statusName,
      isStripe: response.isStripe,
      stripeRedirectUrl: response.stripeRedirectUrl,
      createdAt: response.createdAt,
    };
  },

  /**
   * Maps domain WithdrawalRequest to v2 API request payload.
   * twofaCode is omitted for accounts without 2FA rather than sent as undefined.
   */
  toApiRequest(request: WithdrawalRequest): {amount: number; twofaCode?: string} {
    return {
      amount: request.amount,
      ...(request.twofaCode ? {twofaCode: request.twofaCode} : {}),
    };
  },
};
